// helpers
import errorAlfredFormatErrors from "./alfredFormatErrors";
import errorMonolithFormatErrors from "./monolithFormatErrors";

/**
 * Retourne vrai si l’erreur est issue de l'API monolith.
 * @param {object} param0
 * @param {object} param0.error
 * @return {boolean}
 */
function isMonolithError({ error }) {
  if (!("object" === typeof error?.body)) {
    return false;
  }
  if (!("number" === typeof error.body.code)) {
    return false;
  }
  return true;
}

/**
 * Retourne vrai si l’erreur est issue de l'API Alfred.
 * @param {object} param0
 * @param {object} param0.error
 * @return {boolean}
 */
function isAlfredError({ error }) {
  if (!("number" === typeof error.status)) {
    return false;
  }
  return true;
}

function isCustomError({ error }) {
  if (!("object" === typeof error)) {
    return false;
  }
  if (
    !("string" === typeof error.message) &&
    !("object" === typeof error.data)
  ) {
    return false;
  }
  return true;
}

/**
 *
 * @param {object} param0
 * @param {*} param0.error
 * @param {import("react-intl").IntlShape} param0.intl
 * @return {object}
 */
export default function errorFormat({ error, intl }) {
  if (isMonolithError({ error })) {
    return errorMonolithFormatErrors({
      errorList: error?.body?.errors ?? {},
      intl,
    });
  } else if (isAlfredError({ error })) {
    return {
      message:
        error?.body?.errors?.[0]?.detail ??
        intl.formatMessage({
          defaultMessage: "Une erreur est survenue.",
        }),
      list: errorAlfredFormatErrors({
        errorList: error?.body?.errors?.[0]?.meta?.fields ?? {},
      }),
    };
  } else if (isCustomError({ error })) {
    return {
      message:
        error?.message ??
        intl.formatMessage({
          defaultMessage: "Une erreur est survenue.",
        }),
      list: error?.data,
    };
  } else {
    return {
      message: intl.formatMessage({
        defaultMessage: "Une erreur est survenue.",
      }),
      list: {},
    };
  }
}
